// extracted by mini-css-extract-plugin
export default {"card":"e2-z"};